import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Fab, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

/**
 * ScrollTopFab - Pulsante flottante "torna su".
 * Nell'area admin lo scroll avviene dentro <main> (App.js, overflowY:auto),
 * non sulla finestra: qui aggancio il listener al contenitore giusto.
 * Compare dopo aver scrollato oltre `threshold` px e riporta in cima.
 */
const ScrollTopFab = ({ threshold = 320 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = document.querySelector("main");
    const target = el || window;
    const getTop = () => (el ? el.scrollTop : window.scrollY);
    const onScroll = () => setVisible(getTop() > threshold);
    onScroll();
    target.addEventListener("scroll", onScroll, { passive: true });
    return () => target.removeEventListener("scroll", onScroll);
  }, [threshold]);

  const handleClick = () => {
    const el = document.querySelector("main");
    (el || window).scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Zoom in={visible}>
      <Fab
        onClick={handleClick}
        size="medium"
        aria-label="Torna su"
        sx={{
          // La ricerca resta sticky su mobile: il FAB serve solo su desktop.
          display: { xs: "none", md: "inline-flex" },
          position: "fixed",
          bottom: { xs: 20, md: 32 },
          right: { xs: 20, md: 32 },
          zIndex: 1200,
          backgroundColor: "#0b3d87",
          color: "white",
          boxShadow: "0 8px 24px -6px rgba(11, 61, 135, 0.5)",
          "&:hover": { backgroundColor: "#082d63" },
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
};

ScrollTopFab.propTypes = {
  threshold: PropTypes.number,
};

export default ScrollTopFab;
